import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../utils/util';
import { Breadcrumbs, Button, Input } from '../../../components/UI/ComponentsUI';
import TruckKanbanService from '../../../services/TruckKanbanService';
import ConfirmModalUI from '../../../components/UI/ConfirmModalUI';
import { validateInputsRequired } from '../../../utils/handleChangeHooks';

const CloseMVI = (props) => {
    const [mvi, setMvi] = useState('');
    const [openModal, setOpenModal] = useState(false);

    const closeModal = () => {
        setOpenModal(false);
    }

    const send = () => {
        closeModal(false);
        setMvi("");
        props.finishMvi(mvi, () => {
            setMvi("");
        })
    }

    return (
        <div>
            <Breadcrumbs id="closeMVI" title={{ icon: "mdi mdi-truck-delivery-outline", label: "Fechar MVI" }} />
            <div className="container" style={{ marginTop: '40px' }}>
                <div className="card" style={{ borderRadius: '10px' }}>
                    <div className="card-content" style={{ padding: '3px', paddingTop: '10px' }}>
                        <div id="mviForm" className='row'>
                            <div className="input-field no-padding col s12">
                                <Input
                                    required
                                    id="mvi"
                                    name="mvi"
                                    label="MVI"
                                    type="text"
                                    value={mvi}
                                    onChange={(evt) => {
                                        setMvi(evt.target.value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full={"true"} onClick={() => {
                                if (validateInputsRequired("mviForm")) {
                                    setOpenModal(true);
                                }
                            }} text={"Fechar"} />
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModalUI
                open={openModal}
                id="messageModalAlert"
                data={{
                    title: translate('validations:attention'), message:
                        <span className="title col s12" style={{ color: 'red' }}>
                            Esta ação irá fechar o MVI e os desenhos contidos em aberto nele não poderão mais ser realocados pelo Logistics
                        </span>
                }}
                showCancel={true}
                onConfirm={send}
                onClose={closeModal}
                onCancel={closeModal}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        finishMvi: (mvi, callback) => {
            dispatch(TruckKanbanService.finishMvi(mvi, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CloseMVI));
